"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORKSPACE_JOB_VALUES_MAX_ROWS = exports.WORKSPACE_JOB_RESULT_FILES = exports.WORKSPACE_JOB_OUTPUT_DIR = exports.WORKSPACE_JOB_VIEW_STATUSES = exports.WORKSPACE_JOB_SCHEDULER_STATUSES = exports.PREVIEW_HASH_PATTERN = exports.JOB_REQUEST_ID_PATTERN = exports.AGENT_WORKSPACE_ID_PATTERN = exports.IDEMPOTENCY_KEY_PATTERN = exports.validateWorkspaceBase = exports.effectiveWorkspaceBase = exports.DEFAULT_WORKSPACE_BASE = void 0;
const mounts_1 = require("./mounts");
exports.DEFAULT_WORKSPACE_BASE = "~/foundry-workspaces";
const effectiveWorkspaceBase = (setting) => setting === null || setting === undefined || setting.trim() === ""
    ? exports.DEFAULT_WORKSPACE_BASE
    : setting;
exports.effectiveWorkspaceBase = effectiveWorkspaceBase;
const validateWorkspaceBase = (path) => {
    if (path === "~") {
        return {
            kind: "refused",
            reason: "host_path_is_root",
            detail: "The workspace directory cannot be the home directory itself: write a folder below it, such as ~/foundry-workspaces.",
        };
    }
    return (0, mounts_1.validateDataRootPath)(path);
};
exports.validateWorkspaceBase = validateWorkspaceBase;
exports.IDEMPOTENCY_KEY_PATTERN = /^[A-Za-z0-9._:-]{1,128}$/;
exports.AGENT_WORKSPACE_ID_PATTERN = /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/;
exports.JOB_REQUEST_ID_PATTERN = /^[1-9][0-9]{0,15}$/;
exports.PREVIEW_HASH_PATTERN = /^[0-9a-f]{64}$/;
exports.WORKSPACE_JOB_SCHEDULER_STATUSES = [
    "queued",
    "running",
    "completed",
    "failed",
    "unknown",
];
exports.WORKSPACE_JOB_VIEW_STATUSES = [
    "waiting",
    "skipped",
    "awaiting_approval",
    "rejected",
    "expired",
    "starting",
    "refused",
    "uncertain",
    "dispatch_refused",
    ...exports.WORKSPACE_JOB_SCHEDULER_STATUSES,
];
exports.WORKSPACE_JOB_OUTPUT_DIR = "outputs";
exports.WORKSPACE_JOB_RESULT_FILES = {
    figure: "figure.png",
    values: "values.csv",
    provenance: "provenance.json",
};
exports.WORKSPACE_JOB_VALUES_MAX_ROWS = 500;
